<template>
  <modal-component :back="back">
    <div class="white-card mt-3 mx-auto" style="max-width: 700px">
      <div class="loader absolute" v-if="loading"></div>
      <h4>Exercices</h4>
      <hr>
      <div class="exercise-list">
        <router-link tag="div" class="exercise bg-block" v-for="(exercise,i) in exercises" :key="i"
                     :to="{name: 'exercise-view',params: {lesson_slug: $route.params.slug,id: exercise.id}}">
          <div class="bg"></div>
          <div class="content">{{ exercise.title }}</div>
        </router-link>
      </div>
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "../../components/LayoutPartials/ModalComponent";
import axios from 'axios'

export default {
  name: "ExerciseList",
  data() {
    return {
      exercises: [],
      loading: false,
      back: {
        name: 'lesson',
        params: {slug: this.$route.params.slug}
      }
    }
  },
  components: {ModalComponent},
  mounted() {
    this.loading = true
    axios.get(`/lesson/${this.$slugId(this.$route.params.slug)}/exercises/`)
      .then(({data}) => {
        this.exercises = data
      })
      .finally(() => this.loading = false)
  }
}
</script>

<style lang="scss" scoped>
.exercise-list {
  display: flex;
  flex-wrap: wrap;
  @include gap-items-x(2%, 2);

  .exercise {
    width: 48%;
    margin-bottom: 20px;
    color: $green;

    .content {
      @include no-break();
    }
  }
}
</style>
